module.exports = __webpack_public_path__ + "static/media/anuja.f041dea4.jpg";